import { reorderablePreview } from '../../shared/components/reorderable.jsx'
import EditableSurveySection from './editable_survey_section.jsx'

export default reorderablePreview(EditableSurveySection, 'DraggableSurveySection')
